import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ListRosterArtists, GetRostersSuccess } from '../action-creators';
import { GET_ROSTERS_SUCCESS } from '../actions';

export const listArtistsAfterLoadEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetRostersSuccess>(GET_ROSTERS_SUCCESS),
    concatMap((action) =>
      action.list.map((r) => new ListRosterArtists(r.id, r.labelId))
    )
  );
